import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dfa9b3e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dfa9b3e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa9b3e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfa9b3e8')) {
      api.createRecord('dfa9b3e8', component.options)
    } else {
      api.reload('dfa9b3e8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dfa9b3e8&scoped=true", function () {
      api.rerender('dfa9b3e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/componentsTeacher/marking-exampaper/index.vue"
export default component.exports